export const nf = (v: number | null | undefined, digits?: number): string => {
  if (v === null || v === undefined || !Number.isFinite(v)) return '—';
  const d = digits ?? (v >= 100 ? 0 : v >= 10 ? 1 : 2);
  return v.toLocaleString('fr-FR', { minimumFractionDigits: d, maximumFractionDigits: d });
};

export const mbps = (v: number | null | undefined) => nf(v);

export const date = (s: string | Date) => new Date(s).toLocaleString('fr-FR', { dateStyle: 'medium', timeStyle: 'short' });

export const day = (s: string | Date) => new Date(s).toLocaleDateString('fr-FR', { dateStyle: 'medium' });

export function duration(seconds: number): string {
  if (!Number.isFinite(seconds)) return '—';
  if (seconds < 60) return `${Math.max(1, Math.round(seconds))} s`;
  if (seconds < 3600) return `${Math.round(seconds / 60)} min`;
  const h = Math.floor(seconds / 3600);
  const m = Math.round((seconds % 3600) / 60);
  return m ? `${h} h ${m} min` : `${h} h`;
}

export function safe<T>(f: () => T, fallback: T): T {
  try {
    return f();
  } catch {
    return fallback;
  }
}
